export default __webpack_public_path__ + "static/media/club_banner.24ed2f37.jpg";